export default class CSSUtils {
  public static getSizeNumberFromPx(sizeInPx: string): number {
    return Number(sizeInPx.replace("px", ""));
  }
}
